import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth.jsx";
import { BrandProvider } from "@/lib/brand.jsx";

import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Clients from "@/pages/Clients";
import Projects from "@/pages/Projects";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Expenses from "@/pages/Expenses";
import Payments from "@/pages/Payments";
import Templates from "@/pages/Templates";
import TemplateEditor from "@/pages/TemplateEditor";
import Settings from "@/pages/Settings";
const getDefaultRoute = (hasModuleAccess) => {
  if (hasModuleAccess("Dashboard")) return "/";
  if (hasModuleAccess("Leads")) return "/leads";
  if (hasModuleAccess("Clients")) return "/clients";
  if (hasModuleAccess("Projects")) return "/projects";
  if (hasModuleAccess("Invoices")) return "/invoices";
  if (hasModuleAccess("Expenses")) return "/expenses";
  if (hasModuleAccess("Settings")) return "/settings";
  return "/login";
};

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  const token = localStorage.getItem("ah_token");
  if (loading) return null;
  if (!token && !user) return <Navigate to="/login" replace />;
  if (user?.status === "Disabled") return <Navigate to="/login" replace />;
  return children;
};

const ModuleRoute = ({ module, children }) => {
  const { hasModuleAccess } = useAuth();
  if (!hasModuleAccess(module)) {
    return <Navigate to={getDefaultRoute(hasModuleAccess)} replace />;
  }
  return children;
};

function AppRoutes() {
  const { user, hasModuleAccess } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<ModuleRoute module="Dashboard"><Dashboard /></ModuleRoute>} />
        <Route path="leads" element={<ModuleRoute module="Leads"><Leads /></ModuleRoute>} />
        <Route path="clients" element={<ModuleRoute module="Clients"><Clients /></ModuleRoute>} />
        <Route path="projects" element={<ModuleRoute module="Projects"><Projects /></ModuleRoute>} />
        <Route path="invoices" element={<ModuleRoute module="Invoices"><Invoices /></ModuleRoute>} />
        <Route path="invoices/:id" element={<ModuleRoute module="Invoices"><InvoiceDetail /></ModuleRoute>} />
        <Route path="payments" element={<ModuleRoute module="Payments"><Payments /></ModuleRoute>} />
        <Route path="expenses" element={<ModuleRoute module="Expenses"><Expenses /></ModuleRoute>} />
        <Route path="templates" element={<ModuleRoute module="Templates"><Templates /></ModuleRoute>} />
        <Route path="templates/:id" element={<ModuleRoute module="Templates"><TemplateEditor /></ModuleRoute>} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to={user ? getDefaultRoute(hasModuleAccess) : "/login"} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <BrandProvider>
            <AppRoutes />
            <Toaster position="top-right" theme="light" richColors />
          </BrandProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
